import React, { useContext, useMemo, useState, useEffect } from 'react';
import styled from 'styled-components';
import BookChapterList from '../components/BookChapterList';
import BookChapterText from './BookChapterText';
import { useForceRender } from '../../../hooks/useForceRender';
import ModuleContext from '../../../CMFW/context/ModuleContext';
import BookModel from '../../../models/BookModel';
import BookChapterModel from '../../../models/BookChapterModel';
import ItemLayout from '../../../CMFW/layout/ItemLayout';
import { LoadingItem } from '../../../CMFW/layout/Loading';
import { INavigationStep } from 'types/navigation';
import { IRefIds } from 'constants/refs';

type IProps = {
  navigationPath?: INavigationStep[];
};

const BookChapter: React.FC<IProps> = ({ navigationPath }) => {
  const [bookChapterId, setBookChapterId] = useState(0);
  const [bookChapterTextId, setBookChapterTextId] = useState(0);

  const forceRender = useForceRender();

  const bookModel = useContext(ModuleContext) as BookModel;

  // Process navigation path
  useEffect(() => {
    if (navigationPath && navigationPath.length > 0) {
      // First step is BookChapter
      const chapterStep = navigationPath.find((step) => step.ref === IRefIds.bookChapter);
      if (chapterStep) {
        setBookChapterId(chapterStep.refId);
      }

      // Second step might be BookChapterText
      const textStep = navigationPath.find((step) => step.ref === IRefIds.bookChapterText);
      if (textStep) {
        setBookChapterTextId(textStep.refId);
      }
    }
  }, [navigationPath]);

  const bookChapterModel = useMemo(() => {
    const rem = new BookChapterModel({ render: forceRender, courseId: bookModel.courseId });
    if (bookChapterId) {
      rem.loadItemEdit(bookChapterId);
      rem.bookModel = bookModel;
    }
    return rem;
  }, [forceRender, bookChapterId, bookModel]);

  const onEditChapter = (chapterId: number) => {
    setBookChapterId(chapterId);
    setBookChapterTextId(0); // Reset text selection when changing chapters
  };

  return (
    <Container>
      <BookChapterList onEditChapter={onEditChapter} editingChapterId={bookChapterId} key={bookChapterId} />
      <ModuleContext.Provider value={bookChapterModel}>
        <ItemLayout>
          <BookChapterText bookChapterTextId={bookChapterTextId} />
        </ItemLayout>
        <LoadingItem />
      </ModuleContext.Provider>
    </Container>
  );
};

export default BookChapter;

const Container = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;
